import { Flex, Box, Heading, Text, Stack, Button, useToast, Spinner } from "@chakra-ui/react";
import PropertyCard from "../Cards/PropertyCard";
import { useState, useEffect } from 'react';
import Slider from 'react-slick';
import { useMediaQuery } from '@chakra-ui/react';
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css';
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';
import { useNavigate } from 'react-router-dom';
import { SEARCH_PROPERTIES_MARKETPLACE } from '../../Components/Graphql/Queries'
import { useQuery } from '@apollo/client';


function NextArrow(props) {
  return (
    <button {...props} style={{ backgroundColor: "transparent" }} ><ChevronRightIcon fontSize="54px" color="#002B5B" /> </button>
  );

};
function PrevArrow(props) {
  return (
    <button {...props} style={{ backgroundColor: "transparent" }} ><ChevronLeftIcon fontSize="54px" color="#002B5B" /> </button>
  );

}


function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", background: "green" }}
      onClick={onClick}
    />
  );
}
const OurMarketPlace = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,

    responsive: [
      {
        breakpoint: 1244,
        settings: {
          slidesToShow: 1,
        }
      }

    ]

  };
  const toast = useToast();
  const [cardData, setCardDat] = useState(null);
  const [isLessThan1224] = useMediaQuery('(max-width: 1244px)');
  const navigate = useNavigate();
  const { loading, error, data } = useQuery(SEARCH_PROPERTIES_MARKETPLACE, {
    variables: {
      location: "US",
    },
  });
  useEffect(() => {

    console.log("error:", error)
    console.log("loading:", loading)
    console.log("data:", data)

    if (data != undefined) {
      console.log("data of properties: ", data.searchPropertiesByMarketplace);
      setCardDat(data.searchPropertiesByMarketplace);

    }
    if (error != undefined) {
      toast({
        title: 'error',
        description: error.message,
        status: 'error',
        duration: 4000,
        isClosable: true
      });
    }
  }, [data, loading, error]);

  return (

    <Stack minH="500px" justifyContent="center" my="100px" align="center" px={{ base: "54px", sm: "20vw" }}>
      {loading ? <Spinner color="#0a58ca" size="lg" /> :

        cardData && cardData.length != 0 ?
          cardData.length <= 3 ?
            <Flex w="100%" align="center" justifyContent="center"  maxWidth="1140px" gap="32px" wrap="wrap" >
              {cardData.map((data, index) => (
                <PropertyCard key={index} propertyImg={"https://redswan.io/wp-content/uploads/2022/07/celebation-01.webp"} data={data} />
              ))}
            </Flex> :
            <Slider  {...settings} style={{ maxWidth: "1140px", width: isLessThan1224 ? "100%" : "" }} >
              {cardData.map((data, index) => (
                <PropertyCard key={index} propertyImg={"https://redswan.io/wp-content/uploads/2022/07/celebation-01.webp"} data={data} />
              ))}

            </Slider> :
          <Text mb="56px">No Property to Display</Text>

      }
      <Button onClick={() => { navigate('/marketplace') }} _hover={{ bgColor: "#002B5B", color: "white" }} fontSize="20px" mt="48px" border="1px solid #002B5B" bgColor="transparent" color="#002B5B" p="12px 24px">
        Visit the Marketplace
      </Button>

    </Stack>





  );
}

export default OurMarketPlace;